import { useEffect } from 'react';
import { DELAY } from '../../../constants/GeneralConstants';
import { ScrollUtil } from '../../../util/ScrollUtil';
const scrollToFirstError = (err, path = '') => {
    const errorRecord = Object.values(err).find((element, index) => {
        if (element !== null && typeof element === 'object') {
            path = path ? `${path}.${Object.keys(err)[index]}` : path + Object.keys(err)[index];
            return true;
        }
        return false;
    });
    if (errorRecord && 'type' in errorRecord) {
        const element = document.getElementById(path);
        ScrollUtil.scrollToElement(element, true, 'center');
    }
    else if (errorRecord) {
        scrollToFirstError(errorRecord, path);
    }
};
export function useScrollToFirstFormError(formState, isScrollingEnabled = false) {
    useEffect(() => {
        if (Object.keys(formState.errors).length === 0 || !isScrollingEnabled) {
            return;
        }
        setTimeout(() => {
            scrollToFirstError(formState.errors);
        }, DELAY.DELAY_250);
    }, [formState.errors, isScrollingEnabled]);
}
